import React, { useState, useEffect, useMemo } from 'react';
import ModalComponent from '../ModalComponent';
import {customers as customersDuck, modals} from '../../ducks/index';
import {Button} from 'react-bootstrap';
import {entity as checklistItems} from '../../ducks/checklistItems';
import {ssatbComponents, schoolYears} from '../../ducks/index';
import {duckify, filterDuck, singleDuck} from "../../utils/duckify";
import {compose} from "redux";
import SchoolYearSelect from "components/SchoolYearSelect";

import './styles/SsatbComponentEditor.scss';


const SsatbComponentEditor = ({schoolYears, dispatch, school_year_id})  => {
  const [components, setComponents] = useState([]);
  const [schoolYearId, setSchoolYearId] = useState(school_year_id);
  const [items, setItems] = useState([])

  const schoolYear = useMemo(
    () => schoolYears.ready && (schoolYears.find(year => year.id == schoolYearId) || schoolYears[0]),
    [schoolYearId, schoolYears.ready, schoolYears.length]
  )

  // updates the list of components and checklist items  when school year id is changed
  // we can't use the withSchoolYear hoc here because we can't get query params from the url
  // since this is a modal
  useEffect(() => {
    if (schoolYear) {
      updateComponents();
      updateChecklistItems();
    }
  }, [schoolYear])

  const updateChecklistItems = () => {
    dispatch(checklistItems.actions.load({school_year_id: schoolYear.id, type: 'AdmissionsChecklistItem'}, "components"))
      .then((response) => {
        const checklistItemValues = response.entities.checklistItems;
        const itemsById = Object.keys(checklistItemValues || []).map((key) => checklistItemValues[key]);
        setItems(itemsById)})
  }

  const updateComponents = () => {
    dispatch(ssatbComponents.actions.load({type: 'AdmissionsChecklistItem',school_year_id: schoolYear.id}, "components"))
      .then((response) => {
        const ssatbComponents = response.entities.ssatbComponents
        const componentsById = Object.keys(ssatbComponents || []).map((key) => ssatbComponents[key]);
        setComponents(componentsById) })
  }

  const onSubmit = () => {
    dispatch(ssatbComponents.actions.save(components)).then(() => {
      dispatch(modals.actions.hide())
    })
  }

  const handleChange = (event) => {
    // find the targeted component by index
    components[event.target.id].checklist_item_id = event.target.value;
    setComponents([...components])
  }

  return (<ModalComponent
    buttons={[<Button className='btn btn-primary' onClick={onSubmit}>Submit</Button>]}>
    <div className={'center'}>
    {
      schoolYears.ready && (
        <SchoolYearSelect
          onSelect={(year) => setSchoolYearId(year)}
          schoolYearId={schoolYear.id}
          schoolYears={schoolYears}
        />
      )
    }
    </div>
    <table className='table'>
      <thead>
      <tr>
        <th>SAO Component</th>
        <th>Associated Checklist Item</th>
      </tr>
      </thead>
      <tbody>
      {components.map(function (ssatbComponent, index) {
        return (<tr>
          <td>{ssatbComponent ? ssatbComponent.component_name : ""}</td>
          <td><select id={index}
                      className={"ssatb_checklist_item"}
                      value={ssatbComponent && ssatbComponent.checklist_item_id ? ssatbComponent.checklist_item_id : ""}
                      onChange={(e) => handleChange(e)}>
            <option value=""></option>
            {items.map(function (item) {
              return (<option value={item.id}>{item.name}</option>)
            })}
          </select></td>
        </tr>)
      })}
      </tbody>
    </table>
  </ModalComponent>)
}

const mapDucksToProps = (props) => {
  return {schoolYears: schoolYears}
};


export default compose(
  duckify(mapDucksToProps)
)(SsatbComponentEditor)
